import { FunctionComponent } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { PlanningQuestion } from 'src/types/planning';
import { SectionTitle, SectionCollapseIcon } from '../../styled';
import { QuestionsHeaderRow } from './styled';

interface Props {
    questions: PlanningQuestion[];
    collapsible: boolean;
    expanded: boolean;
    onToggleExpanded: () => void;
}

const QuestionsHeader: FunctionComponent<Props> = ({
    questions,
    collapsible,
    expanded,
    onToggleExpanded
}) => (
    <QuestionsHeaderRow collapsible={collapsible}>
        <SectionTitle>
            {collapsible
                ? `${questions.length} question${
                      questions.length !== 1 ? 's' : ''
                  } to refine the plan`
                : 'A few questions before we proceed'}
        </SectionTitle>
        {collapsible && (
            <SectionCollapseIcon onClick={onToggleExpanded}>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </SectionCollapseIcon>
        )}
    </QuestionsHeaderRow>
);

export default QuestionsHeader;
